export default __webpack_public_path__ + "static/media/creditCard.00de79b8.svg";